var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{class:{ 'moblie': _vm.isMoblie },attrs:{"id":"app"}},[_c(_vm.layout,{key:_vm.$route.name,tag:"component"})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }